module.exports = __webpack_public_path__ + "media/images/icons/flags/MA-5d748d6d8ed66edc7bf6c8b91799554e.svg";